// extracted by mini-css-extract-plugin
export var errorIcon = "_is-1";
export var nameLogo = "_is-0";